const PASS_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'fbclid'];

/**
 * Leva os parâmetros de rastreamento da página para o checkout da Hotmart.
 * - utm_* e fbclid: atribuição no Meta (o pixel da Hotmart cria o _fbc a partir do fbclid)
 * - src: só é copiado da página se o link de checkout ainda não tiver src fixo
 * - sck: origem|campanha|anúncio — aparece no relatório de vendas da Hotmart
 */
export function getCheckoutUrlWithUtms(baseUrl: string): string {
  if (typeof window === 'undefined') return baseUrl;

  const current = new URL(window.location.href).searchParams;
  const checkout = new URL(baseUrl);

  PASS_PARAMS.forEach((param) => {
    const value = current.get(param);
    if (value) checkout.searchParams.set(param, value);
  });

  const pageSrc = current.get('src');
  if (pageSrc && !checkout.searchParams.has('src')) {
    checkout.searchParams.set('src', pageSrc);
  }

  if (!checkout.searchParams.has('sck')) {
    const sck = ['utm_source', 'utm_campaign', 'utm_content']
      .map((p) => current.get(p) || '')
      .filter(Boolean)
      .join('|');
    if (sck) checkout.searchParams.set('sck', sck);
  }

  return checkout.toString();
}

/**
 * Checkout com todos os parâmetros de rastreamento (inclusive os da primeira entrada
 * na sessão) e os dados do lead pré-preenchidos na Hotmart (name, email, telefone).
 */
export function buildPrefilledCheckoutUrl(
  baseUrl: string,
  tracking: Record<string, string>,
  lead: { name: string; email: string; phone: string },
): string {
  const checkout = new URL(getCheckoutUrlWithUtms(baseUrl));

  Object.entries(tracking).forEach(([param, value]) => {
    if (value && !checkout.searchParams.has(param)) checkout.searchParams.set(param, value);
  });

  if (!checkout.searchParams.has('sck')) {
    const sck = [tracking.utm_source, tracking.utm_campaign, tracking.utm_content].filter(Boolean).join('|');
    if (sck) checkout.searchParams.set('sck', sck);
  }

  checkout.searchParams.set('name', lead.name);
  checkout.searchParams.set('email', lead.email);
  const digits = lead.phone.replace(/\D/g, '');
  if (digits.length >= 10) {
    checkout.searchParams.set('phoneac', digits.slice(0, 2));
    checkout.searchParams.set('phonenumber', digits.slice(2));
  }

  return checkout.toString();
}
